/**
 * Turns a number an agent typed into the softphone dialpad into E.164.
 *
 * Unprefixed numbers are taken as Indian. Mirrors
 * CommonCallHelper#normalize_call_number, which re-checks it server-side, so
 * the widget can reject a bad number before a dial is attempted.
 *
 * @param {string} input
 * @returns {string|null} E.164 number, or null when it cannot be one.
 */
export const normalizeDialNumber = input => {
  const raw = String(input || '').trim();
  const digits = raw.replace(/\D/g, '');
  if (raw.startsWith('+')) {
    return digits.length >= 8 && digits.length <= 15 ? `+${digits}` : null;
  }

  // "0XXXXXXXXXX" and "91XXXXXXXXXX" are the same ten-digit national number.
  const national = digits.replace(/^(?:91|0)(?=\d{10}$)/, '');
  return national.length === 10 ? `+91${national}` : null;
};

// Characters the dialpad input accepts; everything else is dropped as typed.
export const sanitizeDialInput = input =>
  String(input || '').replace(/[^\d+*#\s-]/g, '');
